import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter as Router } from 'react-router-redux';
import CoreLayout from 'layouts/CoreLayout/CoreLayout';
import ReduxToastr from 'react-redux-toastr';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import { StylesProvider, ThemeProvider as StylesThemeProvider } from '@mui/styles';
import { CookiesDisabled } from 'routes/CookiesDisabled';
import { vooptyTheme, vooptyThemeV4 } from '../styles/vooptyTheme';
import { generateClassNameV5 } from '../styles/stylesV5ClassNames';
import { SnackbarProvider } from 'notistack';
import { IconButton, CssBaseline } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import '../styles/ui-components-variables.css';
import '../styles/ui-redesign-variables.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import apiConfig from 'infrastructure/Config';

// Define interfaces
interface AppContainerProps {
  store: any; // Replace with your store type if available
  browserHistory: any; // Replace with your history type if available
}

class AppContainer extends Component<AppContainerProps> {
  private notistackRef: React.RefObject<any>;

  constructor(props: AppContainerProps) {
    super(props);
    this.notistackRef = React.createRef();
  }

  onClickDismiss = (key: string) => (): void => {
    this.notistackRef.current.closeSnackbar(key);
  };

  shouldComponentUpdate(): boolean {
    return false;
  }

  render(): React.ReactNode {
    const { store, browserHistory } = this.props;
    let cookiesDisabled = false;

    try {
      localStorage.getItem('any');
    } catch (e) {
      cookiesDisabled = true;
    }

    return (
      <GoogleOAuthProvider clientId={apiConfig.googleOAuthClientId}>
        <Provider store={store}>
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={vooptyThemeV4}>
              <ThemeProvider theme={vooptyTheme}>
                <StylesProvider generateClassName={generateClassNameV5}>
                  <StylesThemeProvider theme={vooptyTheme}>
                    <CssBaseline />
                    <SnackbarProvider
                      hideIconVariant
                      ref={this.notistackRef}
                      maxSnack={3}
                      action={(key) => (
                        <IconButton onClick={this.onClickDismiss(key)}>
                          <CloseIcon />
                        </IconButton>
                      )}
                    >
                      {cookiesDisabled && <CookiesDisabled />}
                      <ReduxToastr
                        timeOut={4000}
                        newestOnTop={false}
                        preventDuplicates
                        position="top-left"
                        transitionIn="fadeIn"
                        transitionOut="fadeOut"
                        progressBar
                      />
                      <Router history={browserHistory}>
                        <Route path="/" component={CoreLayout} />
                      </Router>
                    </SnackbarProvider>
                  </StylesThemeProvider>
                </StylesProvider>
              </ThemeProvider>
            </MuiThemeProvider>
          </StyledEngineProvider>
        </Provider>
      </GoogleOAuthProvider>
    );
  }
}

export default AppContainer;
